export default __webpack_public_path__ + "static/media/Automation-Testing.92859b70.jpg";